<template>
  <div>
    <div class="sticky-top">
      <div class="container d-print-none bg-dark text-white shadow p-3 mb-5">
        <div class="row">
          <div class="col-3 text-left">
            <a href="" class="btn btn-secondary" @click.prevent="togglePreview()">Back</a>
          </div>
          <div class="col-6 text-center">
            <h3><i class="fas fa-printer"></i> Print Preview</h3>
          </div>
          <div class="col-3 text-right">
            <a href="#!" @click.prevent="print()" class="btn btn-primary">Print</a>
          </div>
        </div>
      </div>
    </div>
    <div class="d-print-block">
        <div class="container bg-white pl-5 pr-5">
          <div class="row section justify-content-start">
            <div class="col-12 text-center pt-5">
              <h1 class="display-4 pt-3 pb-3" v-if="fullName">{{ fullName }}</h1>
              <h1 class="display-4 pt-3 pb-3 text-danger" v-else><i class="fas fa-exclamation-triangle"></i> No name provided</h1>
            </div>
            <div class="col text-center lead" v-if="!streetAddress && !phone && !email && !secondaryPhone">
              <span class="text-danger"><i class="fas fa-exclamation-triangle"></i> At least one form of contact information is required.<br> Please go back and provide any combination of <b>mailing address</b>, <b>phone</b>, or <b>email address</b>.</span>
            </div>
            <div class="col text-center" v-if="streetAddress">
              <p v-if="streetAddress">
                <span>Address</span><br>
                <span v-if="streetAddress">{{ streetAddress }} </span>
                <span v-if="city"><br>{{ city }}, </span>
                <span v-if="state">{{ state }} </span>
                <span v-if="zip">{{ zip }}</span>
              </p>
            </div>
            <div class="col text-center" v-if="phone">
              <p>
                <span>Primary Phone Number<br><span class="">{{ phone }}</span></span>
              </p>
            </div>
            <div class="col text-center" v-if="email">
              <p>
                <span v-if="email">Email<br>{{ email }}</span>
              </p>
            </div>
            <div class="col text-center" v-if="secondaryPhone">
              <p><span>Secondary Phone Number</span><br><span class="">{{ secondaryPhone }}</span></p>
            </div>
            <div class="col text-center" v-if="fax">
              <p><span>Fax</span><br><span class="">{{ fax }}</span></p>
            </div>
            <div class="col-12"><hr></div>
          </div>

          <div class="row section" v-if="objective">
            <div class="col-2 text-right">
                <h4>Objective</h4>
            </div>
            <div class="col-10">
              <p class="pr-5" v-if="objective">{{ objective }}</p>
            </div>
            <div class="col"><hr></div>
          </div>

          <div class="row section">
            <div class="col-2 text-right">
                <h4>Skill<span v-if="skills.length == 1"></span><span v-else>s</span></h4>
            </div>
            <div class="col-10 pl-5" v-if="skills.length > 0">
              <div class="row">
                  <div class="col-4" v-for="(skill) in skills" :key="skill.id"><li>{{ skill.value }}</li></div>
              </div>
              <div class="row" v-if="skillsNotes">
                  <p class="mt-3">{{  skillsNotes }}</p>
              </div>
            </div>
            <div class="col-10" v-else>
              <div class="row">
                <div class="col-12 text-danger lead"><i class="fas fa-exclamation-triangle"></i> Not provided</div>
              </div>
            </div>
            <div class="col-12"><hr></div>
          </div>

          <div class="row section">
            <div class="col-2 text-right">
                <h4>Employment History</h4>
            </div>
            <div v-if="this.employment.length > 0" class="col-10">

              <div v-for="employeer in employment" :employeer="employeer = JSON.parse(employeer.value)" :key="employeer.id">
                <div class="row mb-3">
                  <div class="col-4 lead">{{ employeer.jobTitle }}</div>
                  <div class="col-3">{{ employeer.companyName }}</div>
                  <div class="col-2">{{ employeer.companyLocation }} </div>
                  <div class="col-3">{{ employeer.companyStartDate }} - {{ employeer.companyEndDate }}</div>
                  <div class="col-12">
                    {{ employeer.jobDuties }}
                  </div>
                  <div class="col-12 pt-2" v-if="employeer.jobAccomplishments.length > 0">
                    <i class="pr-3">Accomplishment<span v-if="employeer.jobAccomplishments.length > 1">s</span>:</i>
                    <span v-for="(accomplishment, index) in employeer.jobAccomplishments" :key="accomplishment.id"><span v-if="index !== 0">, </span>{{ accomplishment.value }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="col-10">
              <div class="row">
                <div class="col-12 text-danger lead"><i class="fas fa-exclamation-triangle"></i> Not provided</div>
              </div>
            </div>
            <div class="col"><hr></div>
          </div>

          <div class="row section" v-if="military.length > 0">
            <div class="col-2 text-right">
                <h4>Military Service</h4>
            </div>
            <div v-if="this.military.length > 0" class="col-10">
              <div v-for="service in military" :service="service = JSON.parse(service.value)" :key="service.id">
                <div class="row mb-3">
                  <div class="col-4 lead">{{ service.rank }}</div>
                  <div class="col-3">{{ service.branch }}</div>
                  <div class="col-3">{{ service.serviceStartDate }} - {{ service.serviceEndDate }}</div>
                  <div class="col-12">
                    {{ service.duties }}
                  </div>
                  <div class="col-12 pt-2" v-if="service.accomplishments.length > 0">
                    <i class="pr-3">Accomplishment<span v-if="service.accomplishments.length > 1">s</span>:</i> 
                    <span v-for="(accomplishment, index) in service.accomplishments" :key="accomplishment.id"><span v-if="index !== 0">, </span>{{ accomplishment.value }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="col-10">
              <div class="row">
                <div class="col-12 text-danger"><i class="fas fa-exclamation-triangle"></i> Not provided</div>
              </div>
            </div>
            <div class="col"><hr></div>
          </div>

          <div class="row section"  v-if="education.length > 0">
            <div class="col-2 text-right">
                <h4>Education</h4>
            </div>
            <div v-if="this.education.length > 0" class="col-10">
              <div class="row" v-for="school in education" :school="school = JSON.parse(school.value)" :key="school.id">
                  <div class="col-4"><ul class="mb-0"><li>{{ school.name }}</li></ul></div>
                  <div class="col-3">{{ school.date }} </div>
                  <div v-if="school.degree" class="col-3 pb-2">{{ school.degree }} {{ school.date_accomplished }}</div>
                  <div v-else class="col-5 pb-2"></div>
                  <div class="col-12 pt-2" v-if="school.honors">
                      <i class="pr-3">Academic Honors:</i>
                      <span class="pr-5">{{ school.honors }}</span>
                  </div>
              </div>
            </div>
            <div v-else class="col-10">
              <div class="row">
                <div class="col-12 text-danger"><i class="fas fa-exclamation-triangle"></i> Not provided</div>
              </div>
            </div>
            <div class="col"><hr></div>
          </div>

          <div class="row section" v-if="certificates.length > 0 || certificatesNotes">
            <div class="col-2 text-right">
                <h4>Certifications & Licenses</h4>
            </div>
            <div class="col-10 pl-5" v-if="certificates.length > 0  || certificatesNotes">
              <div class="row" v-if="certificates.length > 0">
                  <div class="col-4" v-for="cert in certificates" :key="cert.id"><ul class='mb-2 pl-1'><li>{{ cert.value }}</li></ul></div>
              </div>
              <div class="row" v-if="certificatesNotes">
                  <p class="mt-3">{{ certificatesNotes }}</p>
              </div>
            </div>
            <div class="col-10" v-else>
              <div class="row">
                <div class="col-12 text-danger"><i class="fas fa-exclamation-triangle"></i> Not provided</div>
              </div>
            </div>
          </div>
          <br>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'preview',
  components: {

  },
  data() {
    return {
      fullName: '',
      phone: '',
      email: '',
      secondaryPhone: '',
      fax: '',
      streetAddress: '',
      city: '',
      state: '',
      zip: '',
      objective: '',
      skills: [],
      skillsNotes: "",
      employment: [],
      military: [],
      education: [],
      certificates: [],
      certificatesNotes: "",
    }
  },
  methods: {
    togglePreview() {
      this.$emit('preview', this.form);
    },

    print() {
      window.print();
    }
  },
  mounted() {
      // Check for local storage. If they exists populate the form data fields.
      if (localStorage.fullName) {
        this.fullName = localStorage.fullName;
      }

      if (localStorage.phone) {
        this.phone = localStorage.phone;
      }

      if (localStorage.secondaryPhone) {
        this.secondaryPhone = localStorage.secondaryPhone;
      }

      if (localStorage.fax) {
        this.fax = localStorage.fax;
      }

      if (localStorage.email) {
        this.email = localStorage.email;
      }

      if (localStorage.streetAddress) {
        this.streetAddress = localStorage.streetAddress;
      }

      if (localStorage.city) {
        this.city = localStorage.city;
      }

      if (localStorage.state) {
        this.state = localStorage.state;
      }

      if (localStorage.zip) {
        this.zip = localStorage.zip;
      }

      if (localStorage.objective) {
        this.objective = localStorage.objective;
      }

      if (localStorage.skills) {
        this.skills = JSON.parse(localStorage.skills);
      }

    if(localStorage.skillsNotes) {
      this.skillsNotes = localStorage.skillsNotes;
    }

    if(localStorage.employment) {
      this.employment = JSON.parse(localStorage.employment);
    }

    if(localStorage.military) {
      this.military = JSON.parse(localStorage.military);
    }

    if(localStorage.education) {
      this.education = JSON.parse(localStorage.education);
    }

      if (localStorage.certificates) {
        this.certificates = JSON.parse(localStorage.certificates);
      }

    if(localStorage.certificatesNotes) {
      this.certificatesNotes =  localStorage.certificatesNotes;
    }
  }
}
</script>

<style>
@page {
  margin: 0;
  padding: 0;
  background-color: #fff;
}

@media print {
  .section {
    page-break-before: avoid;
  }

  div {
    font-size:large;
  }
}
</style>
